import React, { useEffect, useRef, useState } from "react";
import Button from "../modules/Button";
import { GetBaseUrl } from "../modules/getBaseUrl";
import { useDispatch, useSelector } from "react-redux";
import { api } from "../../Services";
import { doLogout } from "../LoginPage/redux/actions";
import { useNavigate } from 'react-router-dom';


function BtnSet(props) {
  const navigate = useNavigate()

  const myRef = useRef(null);
  const dispatch = useDispatch();
  const [Link, setLink] = useState("");
  const personalInfo = useSelector((state) => state.personal.personalInfo);
  const idInfo = useSelector((state) => state.tokens.tokens);
  const incomeInfo = useSelector((state) => state.income.incomeInfo);
  const tokenData = useSelector((state) => state.tokens.tokens);
  const education = useSelector((state) => state.education.eduInfo);

const backToPlace=()=>{
  let url = GetBaseUrl(window.location.href);
  // window.location.replace(url + "/application/submitted-status");
  navigate("/application/submitted-status");

}

  useEffect(() => {
    let currentUrl = window.location.href;
    const cleanedUrl = currentUrl.replace(/^https?:\/\/(www\.)?/, "");
    setLink(cleanedUrl);
  }, []);
  return (
    <div className="btn-set">
      <Button
        onClickHandler={() => backToPlace()}
        type={"only-text"}
        value={"I’ll do this later"}
      />
      <Button
        type={"contained"}
        value={"Submit"}
        disabled={props.disabled}
        onClickHandler={() => props.onSubmit()}
      />
      {/* </div> */}
    </div>
  );
}

export default BtnSet;
